import initPwaInstall from './modules/pwaInstall';

initPwaInstall();
